import { Outlet } from "react-router";

const Device = () => {
	return <Outlet />;
};

export default Device;
